<template>
    <div>
        <h1 class="title is-3">Universal Documents</h1>
        <files :reference-id="null" :reference-type="null" />
    </div>
</template>

<script>
    import Files from '../../components/Files'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        components: {
            Files
        },

        mounted () {
            this.fetchFiles({reference_id: null, reference_type: 'universal'})
        },

        methods: {
            ...mapActions({
                fetchFiles: 'fetchFiles'
            })
        }
    }
</script>
